import { useEffect } from 'react';
import { Avatar, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Color } from '../../../assets/color';
import { api_urls } from '../../../utils/api-urls';
import { DeleteSvg, EditSvg } from '../../../assets/svg';
import RouteHeader from '../../../components/common/RouteHeader';
import DatatableHeading from '../../../components/heading/DatatableHeading';
import DatatableWithSearch from '../../../components/datatable/DatatableWithSearch';
import * as SuperadminActions from '../../../redux/actions/superadminAction';
import * as CommonActions from '../../../redux/actions/commonAction';

const Blogs = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { blogData } = useSelector(state => state?.superadminReducer);

    //* Datatable Columns
    const columns = [
        { name: 'S.No.', selector: row => blogData?.indexOf(row) + 1, width: '80px' },
        { name: 'Title', selector: row => row?.title },
        { name: 'Cover Image', cell: row => <div style={{ padding: '10px' }}><Avatar src={row?.cover_image ? api_urls + row?.cover_image : ''} alt="Profile" style={{ width: '60px', height: '60px', borderRadius: '50%' }} /></div>, },
        { name: 'Content', selector: row => row?.content ? <div onClick={() => dispatch(CommonActions?.openDescriptionModal({ title: 'Content', text: row?.content, type: 'editor' }))} dangerouslySetInnerHTML={{ __html: row?.content?.toString().slice(0, 50) }} style={{ cursor: "pointer" }} /> : 'N/A' },
        {
            name: 'Action',
            cell: row => (
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <div onClick={() => navigate('/content/blogs/edit-blogs', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
                    <div onClick={() => dispatch(SuperadminActions.deleteBlog({ id: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
                </div>
            ),
            right: 'true'
        },
    ];

    useEffect(() => {
        //! Dispatching API
        dispatch(SuperadminActions.getBlogs());
    }, []);

    return (
        <>
            <RouteHeader title={`Blogs`} sub_title={`Manage Blogs for your platform`} url={'/content/blogs/add-blogs'} url_name={'Add New Blog'} />

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <Grid container spacing={6} >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableHeading title={'Blogs Management'} sub_title={'Add, update, or delete blogs'} />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableWithSearch data={blogData} columns={columns} />
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default Blogs;